export const REACT_APP_AUTHENTICATE_TOKEN_NAME =
  process.env.REACT_APP_AUTHENTICATE_TOKEN_NAME;
export const REACT_APP_DOMAIN = process.env.REACT_APP_DOMAIN;
export const REACT_APP_GATEWAY_URL = process.env.REACT_APP_GATEWAY_URL;
export const REACT_APP_GATEWAY_LEARN_URL = process.env.REACT_APP_GATEWAY_LEARN_URL;
export const REACT_APP_GATEWAY_META_URL = process.env.REACT_APP_GATEWAY_META_URL;
export const REACT_APP_GATEWAY_INMOBIUS_URL = process.env.REACT_APP_GATEWAY_INMOBIUS_URL;
export const REACT_APP_CALL_SERVICE_URL =
  process.env.REACT_APP_CALL_SERVICE_URL;
export const REACT_APP_COMS_BASE_URL = process.env.REACT_APP_COMS_BASE_URL;
export const REACT_APP_OMS_BASE_URL = process.env.REACT_APP_OMS_BASE_URL;
export const REACT_APP_TMS_BASE_URL = process.env.REACT_APP_TMS_BASE_URL;

export const MAX_NOTES_LENGTH = 300;
export const MIN_SEARCH_LENGTH = 3;
export const ORDER_CANCELLATION_REQUESTED_STATUS_ID = 4;
export const ORDER_CANCELLED_STATUS_ID = 5;
export const ORDER_MODIFICATION_STATUS_ID = 6;
export const MIN_PASSWORD_LENGTH = 6;
export const MAX_PASSWORD_LENGTH = 64;
export const ONE_HOUR = 1000 * 60 * 60;
export const DEFAULT_ISD_CODE = "+91";
export const DEFAULT_PLATFORM = "web";
export const STUDENT_CALLEE_TYPE_ID = 1;

export const CONSTANTS = {
  ZERO: 0,
  ONE: 1,
};

export const BUSINESS_VERTICAL_IDS = {
  IL: 1,
  SCA: 2,
  META: 3,
  IL_SCHOOLS: 4,
  META_JR: 5,
  INMOBIUS: 7,
};

export const VERTICAL_NAMES = {
  IL: "IL",
  SCA: "SCA",
  META: "Meta",
  IL_SCHOOLS: "IL_Schools",
  META_JR: "Meta_Jr",
  INMOBIUS: "Inmobius",
};

export const PRODUCT_IDS = {
  IL: "300",
  SCA: "900",
  META: "200",
  IL_SCHOOLS: "500",
  META_JR: "600",
  INMOBIUS: "100",
};

export const TENANT_IDS = {
  IL: 1,
  SCA: 7,
  META: 2,
  IL_SCHOOLS: 3,
  META_JR: 2,
  INMOBIUS: 99999,
};

export const API_ENDPOINTS = {
  IL_SEARCH_USER: `${REACT_APP_GATEWAY_LEARN_URL}/api/v1/unified/search-user`,
  SCA_SEARCH_USER: `${REACT_APP_GATEWAY_LEARN_URL}/api/v1/unified/search-user`,
  IL_SCHOOLS_SEARCH_USER: `${REACT_APP_GATEWAY_LEARN_URL}/api/v1/unified/search-user`,
  INMOBIUS_SEARCH_USER: `${REACT_APP_GATEWAY_INMOBIUS_URL}/api/v1/user/search-user-by-phone`,
  META_SEARCH_USER: (id) =>
    `${REACT_APP_GATEWAY_META_URL}/api/v1/user/meta/search-user-by-admission-number/${id}`,
  SEARCH_BRANCHES: `${REACT_APP_TMS_BASE_URL}/search-branches`,
};

export const SEARCH_CARD_CONFIG = [
  {
    key: "uam_id",
    label: "Search by UAM ID",
    placeholder: "Enter UAM ID",
  },
  {
    key: "phone",
    label: "Search by Phone Number",
    placeholder: "Enter Phone Number",
  },
  {
    key: "admission_number",
    label: "Search by Admission Number",
    placeholder: "Enter Admission Number",
  },
];
